import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GuestPage } from "./routes/guest/GuestPage";
import { KioskPage } from "./routes/kiosk/KioskPage";
import { GuestbookPage } from "./routes/guest/GuestbookPage";

// Admin surface is code-split so guest phones never download admin JS.
const AdminLoginPage = lazy(() => import("./routes/admin/AdminLoginPage").then((m) => ({ default: m.AdminLoginPage })));
const AdminLayout = lazy(() => import("./routes/admin/AdminLayout").then((m) => ({ default: m.AdminLayout })));
const AdminPhotosPage = lazy(() =>
  import("./routes/admin/AdminPhotosPage").then((m) => ({ default: m.AdminPhotosPage })),
);
const AdminUsersPage = lazy(() =>
  import("./routes/admin/AdminUsersPage").then((m) => ({ default: m.AdminUsersPage })),
);
const AdminStatsPage = lazy(() =>
  import("./routes/admin/AdminStatsPage").then((m) => ({ default: m.AdminStatsPage })),
);

const AdminTrashPage = lazy(() => import("./routes/admin/AdminTrashPage").then((m) => ({ default: m.AdminTrashPage })));
const AdminGuestbookPage = lazy(() =>
  import("./routes/admin/AdminGuestbookPage").then((m) => ({ default: m.AdminGuestbookPage })),
);

const AdminObservabilityPage = lazy(() =>
  import("./routes/admin/AdminObservabilityPage").then((m) => ({ default: m.AdminObservabilityPage })),
);
const GuestbookPrintPage = lazy(() =>
  import("./routes/admin/GuestbookPrintPage").then((m) => ({ default: m.GuestbookPrintPage })),
);

export function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<GuestPage />} />
          <Route path="/kiosk" element={<KioskPage />} />
          <Route path="/livredor" element={<GuestbookPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminPhotosPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="stats" element={<AdminStatsPage />} />
            <Route path="guestbook" element={<AdminGuestbookPage />} />
            <Route path="guestbook/print" element={<GuestbookPrintPage />} />
            <Route path="observability" element={<AdminObservabilityPage />} />
            <Route path="trash" element={<AdminTrashPage />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
